import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  isShowAddClient : boolean;
  public navigationFromUser : boolean;
   showAddClientTab: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  constructor() { 
    this.showAddClientTab.subscribe(res => {
      
      this.isShowAddClient = res;
    })

  
  }

  

    showAddClient() {
        return this.isShowAddClient;
    }

    SetShowAddClient() {
        this.showAddClientTab.next(true);
    }
}
